import React from 'react'
import {MONTHS} from "../../utils/constants";

export default class MonthDropdown extends React.Component {
	static defaultProps = {
		onChangeCallback: () => console.log('MonthDropdown needs an onChangeCallback function passed as a prop')
	}
	
	constructor(props) {
		super(props)
		
		this.date = new Date()
		
		this.state = {
			monthValue: this.date.getMonth()+''
		}
	}
	
	handleInputChange(event) {
		const newMonthValue = event.target.value
		
		this.setState({
			monthValue: newMonthValue
		}, () => {
			this.props.onChangeCallback(newMonthValue)
		})
	}
	
	render() {
		const monthOptionsList = MONTHS.map(month => (
			<option key={month.value} value={month.value}>{month.name}</option>
		))
		
		return (
			<div className={'select-container'}>
				<p>Change Month:</p>
				<select value={this.state.monthValue} onChange={this.handleInputChange.bind(this)}>
					{monthOptionsList}
				</select>
			</div>
		)
	}
}